import { render, staticRenderFns } from "./FilmCardAdd.vue?vue&type=template&id=3af17694&scoped=true&"
import script from "./FilmCardAdd.vue?vue&type=script&lang=js&"
export * from "./FilmCardAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af17694",
  null
  
)

export default component.exports